export default "__VITE_ASSET__D$m4Tgkg__"